/**
 * Who sees Mira in a client (#2610141), stored as `miraMode` in its Systemkonfiguration: nobody (IRES
 * included), IRES only, or IRES and the client's users with a B licence. A front-end gate only: Mira's
 * nightly run computes every client whatever it says.
 *
 * A leaf without imports, so `Client.ts`, `ClientSetup.ts` and the permissions can all use it.
 */
// In the order every picker offers them: yes first, as Ja / Nein and ASSIST's choices are (Taimoor, 2026-10-30).
export const MIRA_MODES = ["ON", "IRES_ONLY", "OFF"] as const;
export type MiraMode = typeof MIRA_MODES[number];

/** Absent means Nur IRES: what every client had before the setting existed. */
export const DEFAULT_MIRA_MODE: MiraMode = "IRES_ONLY";

/** A stored value as a mode: anything absent or unknown is {@link DEFAULT_MIRA_MODE}. */
export function toMiraMode(value: unknown): MiraMode {
  return (MIRA_MODES as readonly unknown[]).includes(value) ? (value as MiraMode) : DEFAULT_MIRA_MODE;
}
